module.exports = __webpack_public_path__ + "static/image7-a20baf2a6a3093c8b454f8b7b178a42c.jpeg";